import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  API_BASE_URL,
  directToken,
  LIST_OF_CITY,
  LIST_OF_HOSPITAL,
  UPDATE_LOCATION,
} from "../services/end_points";
import { Alert, Button, Col, Input, Row, Select, Typography } from "antd";
const EditArea = ({ data }) => {
  const [alert, setAlert] = useState(null);
  const [addcity, setAddcity] = useState(false);
  const [cityOption, setCityOption] = useState();
  const [editing] = useState(true);
  const [formdata, setFormdata] = useState({
    hospitalId: editing ? data.hospitalId : "",
    city: editing ? data.locationId : "",
    area: editing ? data.area : "",
  });
  const userId = localStorage.getItem("userid");

  const [hospitalOption, setHospitalOption] = useState();

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,

      [name]: value,
    }));
  };

  useEffect(() => {
    getHospital();
    setFormdata({
      hospitalId: data.hospitalId,
      city: data.locationId,
      area: data.area,
    });
  }, [data]);
  const getHospital = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        { headers }
      );
      const data = await response.json();
      setHospitalOption(
        data.list.map((source) => ({
          label: source.hospitalName,
          value: source.id,
        }))
      );
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const id = data.id;
    axios
      .put(`${API_BASE_URL}${UPDATE_LOCATION}${id}`, formdata)
      .then((res) => {
        setFormdata({
          hospitalId: "",
          city: "",
          area: "",
        });
        window.location.reload();
        if (res.status == 200) {
          setAlert(true);
        } // Set success alert
      })
      .catch((err) => {
        console.error(err);
        setAlert(false); // Set error alert
      });
  };

  useEffect(() => {
    getCity();
  }, []);

  const getCity = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_CITY}`, {
        headers,
      });
      const data = await response.json();
      setCityOption(
        data.list.map((source) => ({ label: source.city, value: source.id }))
      );
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  return (
    <>
      {alert && (
        <div marginBottom="20px">
          <Alert
            type="success"
            style={{
              backgroundColor: "#dff0d8",
              color: "green",
              fontSize: "16px",
              borderColor: "#dff0d8",
              textAlign: "center",
            }}
            message={"Location Updated!"}
          />
        </div>
      )}
      <Row>
        <Col xl={24} md={16} lg={20} sm={24}>
          <Row
            gutter={[16, 16]} // Adds spacing between rows and columns
            style={{ marginTop: "20px" }}
          >
            <Col xl={8} md={24} sm={24}>
              <Typography style={{ fontWeight: 550, marginLeft: "15px" }}>
                Select City
              </Typography>
              <Select
                showSearch
                style={{ width: "100%", height: "40px", minWidth: "150px" }}
                name="city"
                value={formdata.city || undefined}
                onChange={(value) => setFormdata({ ...formdata, city: value })}
                options={cityOption}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                dropdownStyle={{
                  maxHeight: "200px", // Set the max height for the dropdown
                  overflowY: "auto", // Enable vertical scrolling
                }}
                dropdownRender={(menu) => <div>{menu}</div>}
              />
            </Col>

            <Col xl={8} md={24} sm={24}>
              <Typography style={{ fontWeight: 550, marginLeft: "15px" }}>
                Area
              </Typography>
              <Input
                required
                id="Area"
                name="area"
                value={formdata.area}
                onChange={handleFormChange}
                style={{
                  height: "40px",
                  fontSize: "14px",
                  width: "100%",
                  minWidth: "150px",
                }}
              />
            </Col>
            <Col xl={8} md={24} sm={24}>
              <Typography style={{ fontWeight: 550, marginLeft: "15px" }}>
                Select Hospital
              </Typography>
              <Select
                showSearch
                style={{ width: "100%", height: "40px", minWidth: "150px" }}
                name="hospitalId"
                value={formdata.hospitalId || undefined}
                onChange={(value) =>
                  setFormdata({ ...formdata, hospitalId: value })
                }
                options={hospitalOption}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                dropdownStyle={{
                  maxHeight: "200px",
                  overflowY: "auto",
                }}
                dropdownRender={(menu) => <div>{menu}</div>}
              />
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "20px",
              justifyContent: "space-between",
            }}
          >
            <Button
              type="button"
              onClick={() =>
                setFormdata({ city: "", area: "", hospitalId: "" })
              }
              style={{
                color: "black",
                border: "solid #1236fa",
                marginRight: "auto",
                width: "85px",
                height: "32px",
                borderRadius: "3vw",
              }}
            >
              Reset
            </Button>
            <Button
              type="submit"
              onClick={handleSubmit}
              style={{
                color: "white",
                background: "#1236fa",
                width: "85px",
                height: "32px",
                borderRadius: "3vw",
              }}
            >
              Submit
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default EditArea;
